module.exports = __webpack_public_path__ + "media/images/invoice_background-b2cb0f87ecf7a4486f7e811af12942b3.svg";